import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ScrollableAnchor from 'react-scrollable-anchor';
import styled from 'styled-components';
import {SOCIAL_NETWORK} from '../../common/constants';
import enveloppe from '../assets/img/envelope.svg';
import facebook from '../assets/img/facebook-square.svg';
import instagram from '../assets/img/instagram.svg';
import logoCleanbill from '../assets/img/logo-cleanbill-white.png';
import mapMarker from '../assets/img/map-marker-alt.svg';
import twitter from '../assets/img/twitter.svg';
import Legal from './LegalComp';

export const TitleButton = styled(Link)`
  background: linear-gradient(to left, rgb(90, 18, 111) 0%, rgb(201, 0, 95) 100%);
  border: 0;
  color: white;
  border-radius: 35px;
  padding: 20px;
  max-width: 100%;
  height: 40px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  font-family: Montserrat-Bold, 'sans-serif';
`;

class Footer extends PureComponent {
  render() {
    return (
      <>
        <ScrollableAnchor id={'contact'}>
          <Container className="container-full footer-container">
            <Row className="footer-row">
              <Col xs={12} md={3} className="cleanbill-logo">
                <img src={logoCleanbill} alt="logo-cleanbill" />
              </Col>
              <Col xs={5} md={{span: 2, offset: 1}} className={'footer-section-title'}>
                <span className="footer-title"> Suivez-nous : </span>
                <div className="icons-list">
                  <a className="social-container" href={SOCIAL_NETWORK.FACEBOOK} target="_blank" rel="noopener noreferrer">
                    <img src={facebook} alt="facebook-icon" className="social-icon" />
                  </a>
                  <div className="social-container">
                    <img src={twitter} alt="twitter-icon" className="social-icon" />
                  </div>
                  <div className="social-container">
                    <img src={instagram} alt="instagram-icon" className="social-icon" />
                  </div>
                </div>
              </Col>
              <Col xs={7} md={3} className={'footer-section-title'}>
                <span className="footer-title">Contactez-nous : </span>
                <div className="contact-infos">
                  <div className="contact-text">
                    <img src={mapMarker} alt="map-marker" className="contact-icon" />
                    <div className="address">
                      <div>39b chemin de l’USCLADE,</div>
                      <div>30340 Saint-Privat des Vieux</div>
                    </div>
                  </div>
                  <div className="contact-text contact-mail">
                    <img src={enveloppe} alt="enveloppe" className="contact-icon" />
                      contact@cleanbill.fr
                  </div>
                </div>
              </Col>
              <Col xs={12} md={3} className="footer-btn">
                <TitleButton to={'/login'}>Mon compte</TitleButton>
              </Col>
            </Row>
          </Container>
        </ScrollableAnchor>
        <Legal />
      </>
    );
  }
}

Footer.propTypes = {};

export default Footer;
